import AnnotationPopupContainer from './AnnotationPopupContainer';

export default AnnotationPopupContainer;